import useNativeListener from './useNativeListener';

interface Props {
    deps?: any[];
    callbackFn?: () => void;
}

function useOnLifecycleChanged({ deps, callbackFn }:Props) {
    useNativeListener('noticeLifecycle', () => {
        console.log('라이프 사이클 변경');
        callbackFn?.();
    }, deps);
}

export default useOnLifecycleChanged;
